/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/experiment.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { V2beta1ExperimentStorageState } from './V2beta1ExperimentStorageState';
import {
  V2beta1ExperimentStorageStateFromJSON,
  V2beta1ExperimentStorageStateFromJSONTyped,
  V2beta1ExperimentStorageStateToJSON,
  V2beta1ExperimentStorageStateToJSONTyped,
} from './V2beta1ExperimentStorageState';

/**
 *
 * @export
 * @interface V2beta1Experiment
 */
export interface V2beta1Experiment {
  /**
   * Output. Unique experiment ID. Generated by API server.
   * @type {string}
   * @memberof V2beta1Experiment
   */
  experiment_id?: string;
  /**
   * Required input field. Unique experiment name provided by user.
   * @type {string}
   * @memberof V2beta1Experiment
   */
  display_name?: string;
  /**
   * Optional input field. Describes the purpose of the experiment.
   * @type {string}
   * @memberof V2beta1Experiment
   */
  description?: string;
  /**
   * Output. The time that the experiment was created.
   * @type {Date}
   * @memberof V2beta1Experiment
   */
  created_at?: Date;
  /**
   * Optional input field. Specify the namespace this experiment belongs to.
   * @type {string}
   * @memberof V2beta1Experiment
   */
  namespace?: string;
  /**
   *
   * @type {V2beta1ExperimentStorageState}
   * @memberof V2beta1Experiment
   */
  storage_state?: V2beta1ExperimentStorageState;
  /**
   * Output. The creation time of the last run in this experiment.
   * @type {Date}
   * @memberof V2beta1Experiment
   */
  last_run_created_at?: Date;
}

/**
 * Check if a given object implements the V2beta1Experiment interface.
 */
export function instanceOfV2beta1Experiment(value: object): value is V2beta1Experiment {
  return true;
}

export function V2beta1ExperimentFromJSON(json: any): V2beta1Experiment {
  return V2beta1ExperimentFromJSONTyped(json, false);
}

export function V2beta1ExperimentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V2beta1Experiment {
  if (json == null) {
    return json;
  }
  return {
    experiment_id: json['experiment_id'] == null ? undefined : json['experiment_id'],
    display_name: json['display_name'] == null ? undefined : json['display_name'],
    description: json['description'] == null ? undefined : json['description'],
    created_at: json['created_at'] == null ? undefined : new Date(json['created_at']),
    namespace: json['namespace'] == null ? undefined : json['namespace'],
    storage_state:
      json['storage_state'] == null
        ? undefined
        : V2beta1ExperimentStorageStateFromJSON(json['storage_state']),
    last_run_created_at:
      json['last_run_created_at'] == null ? undefined : new Date(json['last_run_created_at']),
  };
}

export function V2beta1ExperimentToJSON(json: any): V2beta1Experiment {
  return V2beta1ExperimentToJSONTyped(json, false);
}

export function V2beta1ExperimentToJSONTyped(
  value?: V2beta1Experiment | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    experiment_id: value['experiment_id'],
    display_name: value['display_name'],
    description: value['description'],
    created_at:
      value['created_at'] == null ? value['created_at'] : value['created_at'].toISOString(),
    namespace: value['namespace'],
    storage_state: V2beta1ExperimentStorageStateToJSON(value['storage_state']),
    last_run_created_at:
      value['last_run_created_at'] == null
        ? value['last_run_created_at']
        : value['last_run_created_at'].toISOString(),
  };
}
